<template>
<div>
    <m-global-spinner/>
    <m-global-snackbar/>
    <m-global-alert/>
    <m-global-confirm/>
    <m-global-warn/>
    <m-global-confirm-with-response/>
    <m-global-request-number/>
    <m-global-prompt/>
    <m-global-combo-box-prompt/>
    <m-global-select-prompt/>
    <m-global-code-dialog/>
    <m-global-change-tags/>
    <m-global-excel-export-dialog/>
    <m-global-emoji-search-dialog/>
    <m-global-call-ringing/>
    <m-request-support/>
    <m-global-copy-dialog/>
    <m-global-pick/>
    <m-global-prompt-time/>
    <m-global-technical-details/>
    <m-global-process-dialog/>
    <m-global-sign-in-as/>
</div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>